import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";
import type { TourShow } from "@/lib/data/show/types";

/**
 * Hook to fetch related tour shows for tour navigation
 * Now uses tRPC for type-safe, server-side data fetching
 * Following the exact same pattern as useRelatedFestivals
 */
export function useRelatedTourShows(tour: string | null) {
	const result = trpc.show.getRelatedTourShows.useQuery(
		{ tour: tour! },
		{
			enabled: !!tour,
			...CACHE_TIERS.DYNAMIC, // 5 minutes
		},
	);

	// Cast the data to the expected type for backward compatibility
	return {
		...result,
		data: result.data as TourShow[] | undefined,
	};
}
